import { FC, useMemo } from "react"
import { DLMROI, DLMROIDetails } from "../../_models"
import { DetailCard } from "../../../../../components/layout"


import { sumBy, filter, sortBy } from "lodash"
type Props = {
  details : DLMROI
  cardTitle?: string
  isDoor?: boolean
}

const ROIItems: FC<Props> = ({details, cardTitle = "Item Details", isDoor}) => {
  
  const { items, issuedQty } = useMemo(() =>{
    if (! details) return { items: [], issuedQty : 0} ;

    const items = sortBy(filter(details.roiDetails, (obj) => (! obj?.deleted)), (o) => parseInt(`${o.itemNo}`))
    const issuedQty = sumBy(items, 'quantity');
    return { items, issuedQty };

  }, [details])

  if (! (details && details?.roiDetails && details?.roiDetails.length > 0)) {
    return null;
  }

  return (
  <DetailCard cardTitle={cardTitle}>
    <div className='table-responsive min-h-80px mh-375px'>
      <table
        className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable'
      >
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            <th className="p-2" rowSpan={2} >No</th>
            <th className="p-2" rowSpan={2} >Dimension (W x H) mm</th>            
            { !isDoor && 
            <th className="p-2" rowSpan={2} >Type</th>
            }
            <th className="p-2" rowSpan={2} >Hour Rating</th>
            <th className="p-2 text-center" colSpan={2} >Serial Number</th>
            <th className="p-2" rowSpan={2} >Quantity</th>
            { isDoor && 
            <>
            <th className="p-2">Leaf Type</th>
            <th className="p-2">Vision Panel</th>
            </>
            }
            <th className="p-2" rowSpan={2} >Remarks</th>
          </tr>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            <th className="p-2 text-center">From</th>
            <th className="p-2 text-center">To</th>
          </tr>
        </thead>
        <tbody className='text-gray-800 align-middle fs-7'>
        { items.map((item: DLMROIDetails, idx: number) => (
          <tr key={`roiDetail_${idx}`} >
            <td className="p-2 align-top">
              <div>
                {item?.itemNo ? item?.itemNo : idx + 1 }
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {item.size}
              </div>
            </td>
            { !isDoor && 
            <td className="p-2 align-top">
              <div>
                {item.type}
              </div>
            </td>
            } 
            <td className="p-2 align-top text-center">
              <div>
                {item.hourRating}
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {item.labelFrom}
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {item.labelTo}
              </div>
            </td>
            <td className="p-2 align-top text-center">
              <div>
                {item.quantity}
              </div>
            </td>
            { isDoor && 
            <>
            <td className="p-2 align-top">
              <div>
                {item.doorType}
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {item.visionPanel ? 'YES' : 'NO'}
              </div>
            </td>
            </>
            }
            <td className="p-2 align-top">
              <div>
                {item.remarks}
              </div>
            </td>
          </tr>
        ))
        }
        </tbody>
        <tfoot>
          <tr>
            <td className="p-2 align-top text-end text-muted fw-bold" colSpan={6}>Total quantity of labels issued:</td>
            <td className="p-2 align-top text-center fw-bold">{issuedQty}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </DetailCard>
  )
}

export {ROIItems}